import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { headerDataAutomation } from "app/pages/activation/components/Header/dataAutomationKeys";
import { ACTIVATION_SHARED_TOOLTIP } from "app/pages/activation/components/Header/texts";

import * as SC from "./styles";

type SharedIconSchema = {
    sharedBy: string;
    size?: string;
    className?: string;
};

export const SharedIcon = ({ sharedBy, size = "sm", className }: SharedIconSchema) => (
    <Tooltip
        enabled={!!sharedBy}
        content={translate(ACTIVATION_SHARED_TOOLTIP, { name: sharedBy })}
    >
        <SC.Container
            className={className}
            data-automation={headerDataAutomation.sharedByIcon}
        >
            <SWReactIcons
                iconName="social-share"
                size={size}
                iconColor={colorsPalettes.carbon[100]}
            />
        </SC.Container>
    </Tooltip>
);
